import { useState } from 'react';
import { useDispatch } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/DownloadReferenceForm.css';
import Input from '../CustomElements/Input';
import CustomTitle from '../CustomElements/CustomTitle';
import ConfirmationPage from '../CustomElements/ConfirmationPage';
import CustomButton from '../CustomElements/CustomButton';
import Preloader from '../CustomElements/Preloader';
// Кастомные хуки
import { useButtonValidation } from '../../customHook/useButtonValidation';
import { createFormData, handleUniversalChange } from '../../utils/formUtils';
// Действия Redux
import { newReferenceFromServer } from '../../redux/actions/infocards.action';
import { addError } from '../../redux/actions/error.action';

// Этот компонент отображает форму для загрузки справочника

function DownloadReferenceForm({ closeModal, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();
  const [reference, setReference] = useState({ file: '', name: '' });
  const [isLoading, setIsLoading] = useState(false);
  // Состояния уведомления об успешном добавлении
  const [addSuccess, setAddSuccess] = useState(false);
  const [errors, setErrors] = useState([]);

  // Закрывает модальное окно после успешного добавления
  const handlerCloseModal = () => {
    setErrors([]);
    setAddSuccess(false);
    closeModal();
    setIsLoading(false);
  };

  // Обработчик отправки формы
  const handlerSubmit = async (event) => {
    event.preventDefault();

    setIsLoading(true);
    const payload = createFormData(reference);

    try {
      // Вызываем функцию и ждём завершения
      const result = await dispatch(newReferenceFromServer(payload));
      // Если выполнение успешно, записываем успех
      if (result) {
        setAddSuccess(true);
        setIsLoading(false);
      }
    } catch (error) {
      // Обрабатываем ошибку
      const errorArray = error?.response?.data?.message?.split(';') || [];
      if (error.response?.status === 400 && errorArray) {
        // Если статус 400 и есть массив ошибок
        setErrors(errorArray);
        setIsLoading(false);
      } else {
        // Для других ошибок вызываем addError
        dispatch(
          addError({
            error:
              error?.response?.data?.message ||
              t?.unexpectedError ||
              'Возникла непредвиденная ошибка, обратитесь к администратору системы.',
          })
        );
        setIsLoading(false);
      }
    }
  };
  // Функция для проверки валидности формы
  const isButtonDisabled = useButtonValidation(reference);

  return (
    <section className="reference">
      <CustomTitle titleText={t?.addReferenceTitle || 'ДОБАВЛЕНИЕ НОВОГО СПРАВОЧНИКА'} />
      {addSuccess && (
        <ConfirmationPage
          confirmText={t?.referenceAdded || 'Новый справочник добавлен!'}
          onConfirm={handlerCloseModal}
          addNew={t?.close || 'Закрыть'}
        />
      )}
      {!addSuccess && (
        <>
          <Input
            column="left"
            onChange={(event) => {
              handleUniversalChange(reference, setReference, event, null, null, 'file', 'name');
              setIsLoading(false);
              setErrors([]);
            }}
            onRemove={() => {
              handleUniversalChange(reference, setReference, null, 'isRemove', null, null, 'file', 'name');
              setIsLoading(false);
              setErrors([]);
            }}
            type="file"
            accept=".xlsx,.xls"
            name="file"
            label={t?.referenceFileLabel || 'Файл справочника *'}
            placeholder={t?.selectFilePlaceholder || 'Выберите файл'}
            width="var(--sadr-font-size-420)"
            height="var(--sadr-font-size-60)"
          />
          <Preloader isLoading={isLoading} />
          {errors.length > 0 && (
            <>
              <CustomTitle titleText={t?.errorInfo || 'ИНФОРМАЦИЯ ОБ ОШИБКАХ'} className="highlighted-title" />
              <div className="error-list">
                <ol>
                  {errors.map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ol>
              </div>
            </>
          )}
          <CustomButton
            width="var(--sadr-font-size-420)"
            height="var(--sadr-font-size-60)"
            text={t?.addFile || 'Добавить файл'}
            disabled={isButtonDisabled || errors.length > 0 || isLoading}
            isButton
            margin={'auto 0 var(--sadr-font-size-40) 0'}
            onClick={handlerSubmit}
          />
        </>
      )}
    </section>
  );
}

export default DownloadReferenceForm;
